import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as style from './ArticleStarRating.module.scss';

const maxScore = 5;

const ArticleStarRating = (props) => {
  const { features, className, ...rest } = props;

  const [overallScore, setOverallScore] = useState(4);

  useEffect(() => {
    if (!features?.length) return;

    const featureRatings = features.map(
      (feature) => feature?.featureRating ?? 2.5
    );

    const average = featureRatings.reduce((a, b) => a + b) / features.length;

    const roundedAverage = Math.round(average);

    setOverallScore(roundedAverage);
  }, [features]);

  return (
    <div {...rest} className={`${style.starRating} ${className}`}>
      {Array.from({ length: maxScore })?.map((value, index) => (
        <svg
          className={style.svgElement}
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 10 10"
          xmlSpace="preserve"
          width={14}
          height={14}
        >
          <polygon
            className={`${style.svgStar} ${
              index + 1 <= overallScore ? style.starFilled : ''
            }`}
            points="5,8.04 8.09,10 7.27,6.3 10,3.81 6.4,3.49 5,0 3.6,3.49 0,3.81 2.73,6.3 1.91,10 "
          />
        </svg>
      ))}
    </div>
  );
};

ArticleStarRating.defaultProps = {
  className: '',
};

ArticleStarRating.propTypes = {
  /** Array of features. */
  features: PropTypes.arrayOf(
    PropTypes.shape({
      featureName: PropTypes.string.isRequired,
      featureRating: PropTypes.number.isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
};

export default ArticleStarRating;
